import crossIcon from "src/assets/cross.svg";
import { useToast } from "src/hooks/useToast";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import { getOrderChangeValidation, getOrderDetailsByOrderCode2, updateOrderType } from "src/services/order-api";
import { Autocomplete, Input } from "src/components";
import { Button } from "src/components";
import { useEventStatus } from "src/hooks/useEventStatus";
import { useDispatch } from "react-redux";
import { ordActions } from "src/context/order-slice";

export const CNDN_REMARKS_CODE_INT_MAP = [
  { key: "1", name: "Regular Order" },
  { key: "2", name: "Supply Against Order - No Replenishment" },
  { key: "3", name: "Credit Note - No Replenishment" },
  { key: "4", name: "POB" },
];

const ChangeOrderType = ({ onCloseModal }: { onCloseModal: () => void }) => {
  const [reason, setReason] = useState<string>("");
  const { toast } = useToast();
  const { orderDetailsFiltered } = useSelector((state: RootState) => state.ord);
  const [selectedOrderType, setSelectedOrderType] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { withEventCheck } = useEventStatus();
  const dispatch = useDispatch();
  const orderDetails = orderDetailsFiltered?.[0];

  const handleSaveChanges = async () => {
    if (!selectedOrderType) {
      toast({ description: "Please select order type", variant: "destructive" });
      return;
    }
    if (!reason) {
      toast({ description: "Please enter reason", variant: "destructive" });
      return;
    }
    setIsLoading(true);
    const payloadToValidateInV1 = {
      "action": "ORDER_TYPE_CHANGE",
      "order_number": orderDetails?.order_code,
      "ordertype_code": Number(selectedOrderType?.key)
    }
    const response = await getOrderChangeValidation(payloadToValidateInV1)
    if (response?.data?.success !== "success") {
      toast({ description: response?.data?.message, variant: "destructive" });
      setIsLoading(false);
      return;
    }
    const payload = {
      data: {
        order_id: orderDetails?.order_id_int,
        order_type: Number(selectedOrderType?.key),
        reason: reason,
        order_code: orderDetails?.order_code,
      },
      primary_key: orderDetails?.order_id_int,
      event_type: "ORDER_TYPE_UPDATE",
    };
    try {
      const response = await updateOrderType(payload, orderDetails?.company_code);
      const response2 = await withEventCheck(
        () => {
          return getOrderDetailsByOrderCode2(orderDetails?.order_code, orderDetails?.company_code);
        },
        response?.data?.data?.eventStreamCreated?.streamId,
        orderDetails?.company_code  //M10-12758
      );
      dispatch(ordActions.setOrderDetailsFiltered([response2?.data?.data]));
      if (response?.status !== 200) throw new Error(response?.data?.message);
      toast({ description: "Order type updated successfully", variant: "default" });
      onCloseModal();
    } catch (error: any) {
      toast({ description: error?.response?.data?.message, variant: "destructive" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-y-2 mb-4 w-[340px] max-h-[318px] mx-auto px-6 bg-white p-4 rounded-xl">
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#49484C]">Change Order Type</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>
      <div className="">
        <p className="text-sm mb-2 mt-2 font-normal text-[#666666]">Order Type</p>

        <Autocomplete
          placeholder="Select Order Type"
          suggestionList={CNDN_REMARKS_CODE_INT_MAP}
          displayKey="name"
          uniqueKey="key"
          onSelectionChange={(e: any) => setSelectedOrderType(e)}
        />
      </div>
      <div>
        <p className="text-sm mb-2 mt-2 font-normal text-[#666666]">Reason</p>
        <Input
          type="text"
          placeholder="Enter Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="w-full border py-4 border-[#D0D0D0] rounded-md p-2 h-8"
        />
      </div>

      <Button loaderSize="small" isLoading={isLoading} className="text-white bg-[#8051FF] mt-2" onClick={handleSaveChanges}>
        Save Changes
      </Button>
    </div>
  );
};

export default ChangeOrderType;
